"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _conferenceService;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandService = void 0;
const Service_1 = require("../Service");
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
const events_1 = require("../../events");
/**
 * @ignore
 */
var CommandServiceEvents;
(function (CommandServiceEvents) {
    CommandServiceEvents["Received"] = "received";
})(CommandServiceEvents || (CommandServiceEvents = {}));
/**
 * The CommandService allows the application to [send](#send) text messages or notifications to all conference participants. The service also emits an [received](#received) event to inform the application about received messages.
 *
  ---
 * @noInheritDoc
 */
let CommandService = class CommandService extends Service_1.BaseConferenceService {
    /**
     * @ignore
     * @param sdk
     * @param conferenceService
     */
    constructor(sdk, conferenceService) {
        super(sdk);
        _conferenceService.set(this, void 0);
        __classPrivateFieldSet(this, _conferenceService, conferenceService);
    }
    /**
     * Sends a message, in the form of a basic stream, to all conference participants.
     * @param message - The message to send.
     */
    send(message) {
        return VoxeetApi_1.default.conferences.broadcast({
            conferenceId: this._conferenceId,
            data: {
                message: message,
            },
        });
    }
    onConferenceMessageReceived(e) {
        if (__classPrivateFieldGet(this, _conferenceService).current) {
            const participant = __classPrivateFieldGet(this, _conferenceService).participants.get(e.participantId);
            if (participant) {
                this.emit(CommandServiceEvents.Received, participant, e.message);
            }
        }
    }
};
_conferenceService = new WeakMap();
__decorate([
    Service_1.ConferenceNotNull()
], CommandService.prototype, "send", null);
CommandService = __decorate([
    Service_1.Subscribe([events_1.EventType.ConferenceMessageReceived])
], CommandService);
exports.CommandService = CommandService;
